<template>
    <!--@formatter:off-->
    <div v-if="question.isUseQuestion">
        <div class="q_list" :class="{sub_list: isSub}" @mouseup.stop="changeActiveEditor" @focusin.stop="changeActiveEditorFromFocus">
            <slot name="innerHeader"></slot>

            <div class="sub_select" v-if="isSub && !$slots.innerHeader">
                <span>{{$t('SurveyQuestionViewer_subQuestionOf', {number: parentQuestionNumber, exampleNumbers: parentAnswerConditionText})}}</span>
            </div>

            <div class="q_txt_area">
                <div class="q_txt">
                    <strong>{{$t('SurveyQuestionViewer_questionNumber', {number: questionNumber})}}</strong>
                    <span class="q_tit">
                        <Nl2br tag="output" :text="questionText"/>
                        <p class="q_sub_txt" v-if="isMultiChoice && question.maxChoice">{{$t('SurveyQuestionViewer_maxChoiceCount', {max: question.maxChoice})}}</p>
                        <Nl2br tag="div" className="q_info" v-if="questionDescText" :text="questionDescText" />
                    </span>
                </div>
            </div>

            <div class="bx_include_file" v-if="showImage">
                <div class="image">
                    <img :src="question.image.url" alt="" style="max-width: 100%">
                </div>
            </div>


            <div class="a_txt" v-if="isOneChoice">
                <template v-for="(answer, index) in question.answers">
                <span class="bx_input_rdo">
                    <input type="radio" :name="`answer${question.questionNo}`" class="input_rdo"
                           :id="`answer${answer.answerNo}`" readonly>
                    <label :for="`answer${answer.answerNo}`" class="input_lbl">{{answer.text || $t('SurveyQuestionViewer_inputExample')}}</label>
                    <span v-if="isParentFCFS" class="sub_txt">{{$t('SurveyQuestionViewer_limitCountPerson', {number: answer.limit || 0})}}<template
                            v-if="answer.reservedLimit">&middot;{{$t('SurveyQuestionViewer_reservedLimitCountPerson', {number: answer.reservedLimit})}}</template></span>
                </span>
                    <div class="bx_include_file" v-if="showAnswerImage[index]">
                        <div class="image">
                            <img :src="answer.image.url" alt="" style="max-width: 100%">
                        </div>
                    </div>
                </template>
            </div>

            <div class="a_txt" v-if="isMultiChoice">
                <template v-for="(answer, index) in question.answers">
                <span class="bx_input_chk">
                    <input type="checkbox" :name="`answer${question.questionNo}`" class="input_chk"
                           :id="`answer${answer.answerNo}`" readonly>
                    <label :for="`answer${answer.answerNo}`" class="input_lbl">{{answer.text || $t('SurveyQuestionViewer_inputExample')}}</label>
                    <span v-if="isParentFCFS" class="sub_txt">{{$t('SurveyQuestionViewer_limitCountPerson', {number: answer.limit || 0})}}<template
                            v-if="answer.reservedLimit">&middot;{{$t('SurveyQuestionViewer_reservedLimitCountPerson', {number: answer.reservedLimit})}}</template></span>
                </span>
                    <div class="bx_include_file" v-if="showAnswerImage[index]">
                        <div class="image">
                            <img :src="answer.image.url" alt="" style="max-width: 100%">
                        </div>
                    </div>
                </template>
            </div>

            <div class="a_txt" v-if="isText">
            <span class="bx_input bx_textarea">
                <span class="textarea_info">{{$t('SurveyQuestionViewer_inputTextCount', {count: textLengthValue})}}</span>
                <textarea cols="80" rows="4" maxlength="150" readonly></textarea>
            </span>
            </div>

            <div class="a_txt" v-if="isTable">
                <table class="tbl_rdo">
                    <caption><span class="blind">{{$t('SurveyQuestionViewer_blind_satisfaction')}}</span></caption>
                    <colgroup>
                        <col width="300px">
                        <col v-for="text in tableTexts">
                    </colgroup>
                    <thead>
                    <tr>
                        <th scope="col">
                            <div class="sub_select">
                                <span>{{$t('SurveyQuestionViewer_satisfactionOfQuestionNumber', {number: questionNumber})}}</span>
                            </div>
                        </th>
                        <th scope="col" v-for="text in tableTexts" v-html="text"></th>
                    </tr>
                    </thead>
                    <tbody>
                    <tr v-for="(subQuestion, index) in question.tableQuestions">
                        <th scope="row">
                            <span class="tit_num">{{questionNumber}}-{{index + 1}}.</span>
                            <span class="tit_txt">{{subQuestion.question || $t('SurveyQuestionViewer_inputSatisfactionQuestion')}}</span>
                        </th>
                        <td v-for="(text, index) in tableTexts">
                            <label :for="`s${question.questionNo}${subQuestion.questionNo}${index}`" class="inp_label">
                            <span class="bx_tc">
                                <input type="radio" :name="`s${subQuestion.questionNo}`" :id="`s${question.questionNo}${subQuestion.questionNo}${index}`" class="inp_input">
                                <span class="inp_radio"></span>
                                <span class="blind" v-html="text"></span>
                            </span>
                            </label>
                        </td>
                    </tr>
                    </tbody>
                </table>
            </div>

            <div class="bx_sign_editor" v-if="isSign">
                <div class="in">
                    <span class="img_sign"><img src="@iamteacherpc/assets/iamteacher/editor/img/img_survey_sign.png" alt=""></span>
                    <p class="txt_sign">{{$t('SurveyQuestionEditor_signHere')}}</p>
                </div>
            </div>

            <button ref="editButton" type="button" class="btn_edit">{{$t('SurveyQuestionViewer_edit')}}</button>
        </div>
        <template v-for="(q, index) in question.questions" v-if="showSubQuestion">
            <SurveyQuestionViewer :question="q" :question-index="index" :parent-question-number="questionNumber" :key="q.questionNo" @changeActiveEditor="onChangeActiveEditor"/>
        </template>
    </div>
    <!--@formatter:on-->
</template>

<script>
import Nl2br from 'vue-nl2br';
import {ANSWER_TYPE, TEXT_LENGTH_VALUE} from '@/common/consts/survey.js';
import {REQUEST_STATE} from '@iamteacherpc/consts/request.js';
import whatInput from 'what-input';
import {getSatisfactionStepText} from '@iamteacherpc/utils/satisfactionUtil.js';
import {GET_START_QUESTION_NUMBER, NAMESPACE} from '@common/store/modules/survey/editor.js';
import {createNamespacedHelpers} from 'vuex';

const {mapGetters} = createNamespacedHelpers(NAMESPACE);
export default {
    name: 'SurveyQuestionViewer',
    components: {Nl2br},

    props: {
        isUseStartQuestionNumber: {
            type: Boolean,
            default: true,
        },
        questionIndex: {
            type: Number,
            required: true,
        },
        question: {
            type: Object,
            required: true,
        },
        parentQuestionNumber: {
            type: String,
            default: '',
        },
    },

    computed: {
        ...mapGetters([
            GET_START_QUESTION_NUMBER,
        ]),

        questionNumber() {
            let number = '';

            if (this.isSub) {
                number += this.parentQuestionNumber + '-';
            }

            let questionIndex = this.questionIndex;
            if (this.isUseStartQuestionNumber && !this.isSub) {
                questionIndex += this[GET_START_QUESTION_NUMBER];
            } else {
                questionIndex += 1;
            }

            return number + questionIndex;
        },

            questionText() {
                let questionText = this.question.question || this.$t('SurveyQuestionViewer_inputQuestion');
                if (this.question.mandatory) {
                    questionText += ` (${this.$t('SurveyQuestionViewer_mandatory')})`;
                }
                return questionText;
            },

            questionDescText(){
                return this.question.questionDesc;
            },

            isSub() {
                return !!this.question.parentQuestion;
            },

            isParentFCFS() {
                return this.question.isParentFCFS;
            },

            isOneChoice() {
                return this.question.type === ANSWER_TYPE.ONE_CHOICE;
            },

            isMultiChoice() {
                return this.question.type === ANSWER_TYPE.MULTI_CHOICE;
            },

            isChoice() {
                return this.isOneChoice || this.isMultiChoice;
            },

            showSubQuestion() {
                return !this.isSub && this.isChoice && !this.isParentFCFS;
            },

            isText() {
                return this.question.type === ANSWER_TYPE.TEXT;
            },

            isTable() {
                return this.question.type === ANSWER_TYPE.TABLE;
            },

            isSign() {
                return this.question.type === ANSWER_TYPE.SIGN;
            },

            showImage() {
                return this.question.image && this.question.image.uploadState === REQUEST_STATE.SUCCESS;
            },

            showAnswerImage() {
                return this.question.answers.map(answer => answer.image && answer.image.uploadState === REQUEST_STATE.SUCCESS);
            },

            textLengthValue() {
                return TEXT_LENGTH_VALUE[this.question.textLength];
            },

            tableTexts() {
                return getSatisfactionStepText(this.question.tableColumnLength);
            },

            parentAnswerConditionText() {
                const indexes = [];

                this.question.parentQuestion.answers.forEach((answer, index) => {
                    if (this.question.parentAnswerCondition.find(condition => condition === answer.answerNo)) {
                        indexes.push(this.$t('common_suffixNumber', {number: index + 1}));
                    }
                });

                return indexes.join(', ');
            }
        },

        methods: {
            changeActiveEditorFromFocus() {
                if (whatInput.ask() !== 'keyboard') {
                    return;
                }

                this.$emit('changeActiveEditor', this.questionIndex, this.question.questionNo);
            },

            changeActiveEditor() {
                this.$emit('changeActiveEditor', this.questionIndex, this.question.questionNo);
            },

            onChangeActiveEditor(questionIndex, questionNo) {
                this.$emit('changeActiveEditor', this.questionIndex, questionNo);
            }
        }
    }
</script>

<style scoped>

</style>
